(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gossip-wall"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("gossipDisclaimerOverlay");
  const successOverlay = document.getElementById("gossipSuccessOverlay");
  const content = document.getElementById("gossipContent");
  const agree = document.getElementById("gossipAgree");
  const feed = document.getElementById("gossipFeed");
  const input = document.getElementById("gossipMessage");
  const sendBtn = document.getElementById("postGossip");
  const sortButtons = document.querySelectorAll(".gossip-sort-btn");
  let db = null;
  let successTimeout = null;

  // Emojis kept for future use (do not delete)
  const PRIMARY_EMOJIS = ["❤️", "😂", "😭", "🙏", "✨"];
  const ALL_EMOJIS = [
    "❤️", "😂", "😭", "🙏", "✨", // Primary
    "👍", "😮", "🏆", "🌸", "💕", "😘", "😍", "🎀",
    "💖", "🦋", "😻", "🍭", "🎉", "❣️", "🪩", "🫧", "🍰"
  ];

  // Toggle this to true to show emoji reactions below every post in future
  const SHOW_EMOJIS = false;

  // Sort mode: "newest" (default) or "top" – like YouTube comments
  let currentSort = "newest";

  agree.addEventListener("click", () => {
    overlay.style.display = "none";
    content.style.display = "block";
    initFirebase();
  });

  // sort buttons (Top comments / Newest first)
  sortButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const mode = btn.getAttribute("data-sort");
      if (mode === currentSort) return;
      currentSort = mode;

      sortButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      if (db) {
        loadMessages(); // listener will re‑attach and re‑sort
      }
    });
  });

  function initFirebase() {
    try {
      db = firebase.firestore();
      loadMessages();
    } catch (e) {
      console.error("Firebase not loaded:", e);
    }
  }

  function loadMessages() {
    db.collection("posts")
      .where("status", "==", "approved")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        feed.innerHTML = "";

        const docs = snapshot.docs.slice().sort((a, b) => {
          const ad = a.data();
          const bd = b.data();
          const aUp = typeof ad.upvotes === "number" ? ad.upvotes : 0;
          const bUp = typeof bd.upvotes === "number" ? bd.upvotes : 0;
          const aTime = ad.timestamp?.toMillis ? ad.timestamp.toMillis() : 0;
          const bTime = bd.timestamp?.toMillis ? bd.timestamp.toMillis() : 0;

          if (currentSort === "top") {
            if (bUp !== aUp) return bUp - aUp; // more upvotes first
            return bTime - aTime;             // then newest
          } else { // "newest"
            return bTime - aTime;             // ignore upvotes
          }
        });

        docs.forEach((doc) => {
          const d = doc.data();

          // --- Upvote Logic (Reddit Style) ---
          if (typeof d.upvotes !== "number") d.upvotes = 0;

          const upvoteBtnHtml = `
            <button class="gossip-upvote-btn" data-id="${doc.id}" style="font-size: 1.2rem; padding: 6px 16px; border-radius: 99px; background: #f2f4ff; color: #d8488b; border: none; margin-top: 8px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px;">
              <span class="arrow" style="font-size: 1.4rem; color: #d8488b;">&#9650;</span>
              <span class="upvote-count">${d.upvotes}</span>
            </button>
          `;

          // --- Emoji Logic (Hidden unless SHOW_EMOJIS === true) ---
          let reactionsHtml = "";
          if (SHOW_EMOJIS) {
            if (!d.reactions) {
              d.reactions = {};
              ALL_EMOJIS.forEach(e => d.reactions[e] = 0);
            }

            reactionsHtml = PRIMARY_EMOJIS.map(emoji =>
              `<button class="gossip-reaction-btn" data-id="${doc.id}" data-emoji="${emoji}" style="background:none;border:none;font-size:1.6rem;margin:0 2px;cursor:pointer;">
                 ${emoji} <span class="reaction-count">${d.reactions[emoji] || 0}</span>
               </button>`
            ).join("");

            reactionsHtml += `
              <button class="gossip-reaction-btn more-reactions" data-id="${doc.id}" style="font-weight: bold;">+</button>
            `;
          }

          const item = `
            <div class="gossip-item">
              <div class="gossip-user">${d.user || "Anonymous"}</div>
              <div class="gossip-bubble">${d.text}</div>
              <div class="gossip-time">${new Date(d.timestamp?.toDate()).toLocaleString()}</div>
              <div class="gossip-voting" style="margin-top:6px;">${upvoteBtnHtml}</div>
              ${SHOW_EMOJIS ? `<div class="gossip-reactions" style="margin-top:4px; position:relative;">${reactionsHtml}</div>` : ""}
            </div>
          `;
          feed.insertAdjacentHTML("beforeend", item);
        });

        // Upvote listeners (one‑per‑user)
        document.querySelectorAll(".gossip-upvote-btn").forEach(btn => {
          const postId = btn.getAttribute("data-id");
          const upvotedKey = `gossipUpvoted_${postId}`;

          if (window.localStorage.getItem(upvotedKey)) {
            btn.disabled = true;
            btn.style.opacity = "0.5";
            btn.style.cursor = "not-allowed";
          }

          btn.addEventListener("click", function() {
            if (window.localStorage.getItem(upvotedKey)) {
              alert("You can only upvote once.");
              return;
            }
            upvotePost(postId);
            btn.disabled = true;
            btn.style.opacity = "0.5";
            btn.style.cursor = "not-allowed";
          });
        });

        // Emoji listeners (kept for future)
        if (SHOW_EMOJIS) {
          document.querySelectorAll(".gossip-reaction-btn").forEach(btn => {
            const postId = btn.getAttribute("data-id");
            const reactedKey = `gossipReacted_${postId}`;
            if (window.localStorage.getItem(reactedKey) && !btn.classList.contains("more-reactions")) {
              btn.disabled = true;
              btn.style.opacity = "0.5";
              btn.style.cursor = "not-allowed";
            }
            btn.addEventListener("click", function(e) {
              const emoji = this.getAttribute("data-emoji");
              if (this.classList.contains("more-reactions")) {
                showAllEmojisPopup(postId, this);
              } else {
                if (window.localStorage.getItem(reactedKey)) {
                  alert("You can only react once to a post.");
                  return;
                }
                reactToPost(postId, emoji);
                document.querySelectorAll(`.gossip-reaction-btn[data-id="${postId}"]`).forEach(b => {
                  if (!b.classList.contains("more-reactions")) {
                    b.disabled = true;
                    b.style.opacity = "0.5";
                    b.style.cursor = "not-allowed";
                  }
                });
              }
            });
          });
        }
      });
  }

  // --- Upvote Firestore Logic ---
  async function upvotePost(postId) {
    const upvotedKey = `gossipUpvoted_${postId}`;
    const postRef = db.collection("posts").doc(postId);
    db.runTransaction(async (transaction) => {
      const doc = await transaction.get(postRef);
      if (!doc.exists) return;
      const data = doc.data();
      if (typeof data.upvotes !== "number") data.upvotes = 0;
      data.upvotes += 1;
      transaction.update(postRef, { upvotes: data.upvotes });
      window.localStorage.setItem(upvotedKey, "true");
    });
  }

  // --- Emoji Firestore Logic (keep for future use) ---
  async function reactToPost(postId, emoji) {
    const reactedKey = `gossipReacted_${postId}`;
    const postRef = db.collection("posts").doc(postId);
    db.runTransaction(async (transaction) => {
      const doc = await transaction.get(postRef);
      if (!doc.exists) return;
      const data = doc.data();
      if (!data.reactions) data.reactions = {};
      data.reactions[emoji] = (data.reactions[emoji] || 0) + 1;
      transaction.update(postRef, { reactions: data.reactions });
      window.localStorage.setItem(reactedKey, emoji);
    });
  }

  // --- Emoji Popup logic (keep for future use) ---
  function showAllEmojisPopup(postId, btnElement) {
    const oldPopup = document.querySelector('.emoji-popup');
    if (oldPopup) oldPopup.remove();
    const extraEmojis = ALL_EMOJIS.filter(e => !PRIMARY_EMOJIS.includes(e));
    const reactedKey = `gossipReacted_${postId}`;
    const userReacted = window.localStorage.getItem(reactedKey) !== null;
    const popupHtml = `
      <div class="emoji-popup" style="position: absolute; z-index: 1002; background: #fff0fb; border-radius: 16px; box-shadow: 0 6px 24px rgba(239, 58, 182, 0.16); padding: 13px 16px; display: flex; flex-wrap: wrap; gap: 10px;">
        ${extraEmojis.map(emoji =>
          `<button class="gossip-reaction-btn" data-id="${postId}" data-emoji="${emoji}" 
             style="font-size:1.7rem; background:none; border:none; cursor:pointer;"
             ${userReacted ? 'disabled style="opacity:0.5;cursor:not-allowed;"' : ''}>
             ${emoji}
           </button>`
        ).join("")}
      </div>
    `;
    btnElement.insertAdjacentHTML('afterend', popupHtml);
    const popup = btnElement.nextElementSibling;
    popup.querySelectorAll('.gossip-reaction-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        if (userReacted) {
          alert("You can only react once to a post.");
          popup.remove();
          return;
        }
        reactToPost(postId, btn.getAttribute('data-emoji'));
        popup.remove();
        e.stopPropagation();
      });
    });
    setTimeout(() => {
      document.addEventListener('click', function closePopup(event) {
        if (!popup.contains(event.target) && event.target !== btnElement) {
          popup.remove();
          document.removeEventListener('click', closePopup);
        }
      });
    }, 50); 
  }

  // --- Show Success Popup Function ---
  function showSuccessPopup(message, isError = false) {
    // Clear any existing timeout
    if (successTimeout) {
      clearTimeout(successTimeout);
    }
    
    const successIcon = document.getElementById("gossipSuccessIcon");
    const successTitle = document.getElementById("gossipSuccessTitle");
    const successMessage = document.getElementById("gossipSuccessMessage");
    
    // Update icon and title based on message type
    if (isError) {
      successIcon.textContent = "💕";
      successTitle.textContent = "Oops! 💖";
    } else {
      successIcon.textContent = "✨";
      successTitle.textContent = "Success! 💖";
    }
    
    // Update message if provided
    if (message) {
      successMessage.textContent = message;
    }
    
    // Show popup
    successOverlay.style.display = "flex";
    
    // Auto-hide after 5.5 seconds
    successTimeout = setTimeout(() => {
      successOverlay.style.display = "none";
      successTimeout = null;
    }, 5500);
  }

  // --- Post Submission Logic ---
  sendBtn.addEventListener("click", async () => {
    const text = input.value.trim();
    if (!text) {
      showSuccessPopup("Type your gossip before sending!", true);
      return;
    }
    await db.collection("posts").add({
      user: "Anonymous",
      text: text,
      timestamp: new Date(),
      status: "pending",
      upvotes: 0
    });
    input.value = "";
    showSuccessPopup("Your message was sent and is pending approval. It'll appear after it's approved by an admin!");
  });
}); // END DOMContentLoaded

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
